<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <v-toolbar-title>GL Post Account</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6 v-if="!newGLPostAcct">
              <v-autocomplete
                :label="labels.acctYr"
                :items="acctYrList"
                v-model="glPostAcctForm.acctYr"
                item-text="label"
                item-value="value"
                @change="fetchGLPostAcct"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.acctYr }}</v-subheader>
              <div class="queryValue">{{ glPostAcctForm.acctYr }}</div>
            </v-flex>
          </v-layout>
          <v-btn color="primary" dark class=" mr-2" v-if="!currYrExist" @click="doNew">
            Add Current Year
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-divider></v-divider>
          <template v-if="showDet">
            <v-layout wrap>
              <v-flex xs6>
                <div class="body-2">Original Balance</div>
              </v-flex>
              <v-flex xs6>
                <div class="body-2">Local Balance</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-for="item in acctMth" :key="item.value">
              <v-flex xs6>
                <v-text-field
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="item.label"
                  v-model="glPostAcctForm['origBal' + item.value]"
                  :error-messages="errors.collect('origBal' + item.value)"
                  :data-vv-name="'origBal' + item.value"
                  :data-vv-as="labels.origBal + ' ' + item.label"
                  :disabled="!newGLPostAcct"
                  :key="'origBal' + item.value"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="item.label"
                  v-model="glPostAcctForm['localBal' + item.value]"
                  :error-messages="errors.collect('localBal' + item.value)"
                  :data-vv-name="'localBal' + item.value"
                  :data-vv-as="labels.localBal + ' ' + item.label"
                  :disabled="!newGLPostAcct"
                  :key="'localBal' + item.value"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newGLPostAcct">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-btn class="mr-2" color="error" @click="doCancel">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" dark class=" mr-2" v-if="newGLPostAcct" @click="doCreate">
              Save Record
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </template>
        </v-container>
      </v-card-text>
      <confirm ref="confirm"> This account no. is set to close in {{ glPostAcctForm.yrClosed }}. Do you still want to proceed? </confirm>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      acctYrList: [],
      labels: {
        glacctNo: 'GL Account No.',
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        description: 'Description',
        curr: 'Curency',
        parentAcctNo: 'Parent Account No.',
        acctYr: 'Accounting Year',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        modifiedProgId: 'Modified Program',
        origBal: 'Original Balance',
        localBal: 'Local Balance'
      },
      glPostAcctForm: {
        branch: null,
        brnDesc: null,
        glacctNo: null,
        fund: null,
        fundDesc: null,
        acctNoSfx: null,
        acctNoSfxDesc: null,
        acctYr: null,
        description: null,
        curr: null,
        currDesc: null,
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null,
        yrClosed: null,
        origBalBf: parseFloat(0).toFixed(2),
        origBal01: parseFloat(0).toFixed(2),
        origBal02: parseFloat(0).toFixed(2),
        origBal03: parseFloat(0).toFixed(2),
        origBal04: parseFloat(0).toFixed(2),
        origBal05: parseFloat(0).toFixed(2),
        origBal06: parseFloat(0).toFixed(2),
        origBal07: parseFloat(0).toFixed(2),
        origBal08: parseFloat(0).toFixed(2),
        origBal09: parseFloat(0).toFixed(2),
        origBal10: parseFloat(0).toFixed(2),
        origBal11: parseFloat(0).toFixed(2),
        origBal12: parseFloat(0).toFixed(2),
        origBal13: parseFloat(0).toFixed(2),
        localBalBf: parseFloat(0).toFixed(2),
        localBal01: parseFloat(0).toFixed(2),
        localBal02: parseFloat(0).toFixed(2),
        localBal03: parseFloat(0).toFixed(2),
        localBal04: parseFloat(0).toFixed(2),
        localBal05: parseFloat(0).toFixed(2),
        localBal06: parseFloat(0).toFixed(2),
        localBal07: parseFloat(0).toFixed(2),
        localBal08: parseFloat(0).toFixed(2),
        localBal09: parseFloat(0).toFixed(2),
        localBal10: parseFloat(0).toFixed(2),
        localBal11: parseFloat(0).toFixed(2),
        localBal12: parseFloat(0).toFixed(2),
        localBal13: parseFloat(0).toFixed(2),
        createdProgId: null,
        modifiedProgId: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      acctMth: [
        { label: 'B/F', value: 'Bf' },
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' }
      ],
      newGLPostAcct: false,
      showDet: false,
      currYrExist: false,
      comp: null
    }
  },
  created() {
    if (!this.glacctNoId.branch && !this.glacctNoId.glacctNo) {
      const jsonData = JSON.parse(sessionStorage.getItem('glacctNo'))
      if (jsonData && jsonData.branch && jsonData.glacctNo) {
        this.$store.commit('GLACCTNO_COMMIT_KEY', jsonData)
      } else {
        this.$router.push({ name: 'glAcctNoList' })
      }
    }
  },
  methods: {
    formatDec(field) {
      if (this.glPostAcctForm[field]) {
        this.glPostAcctForm[field] = parseFloat(this.glPostAcctForm[field]).toFixed(2)
      } else {
        this.glPostAcctForm[field] = parseFloat(0).toFixed(2)
      }
    },
    async getComp() {
      const apiURI = this.menu.glPostAcctYrComp
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result
        this.comp = data
      }
    },
    async fetchGLAcctNo() {
      const apiURI = this.menu.glacctNo
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glPostAcctForm.branch = data.glacctNo.branch
            if (data.branch) {
              this.glPostAcctForm.brnDesc = data.branch.brnDesc
            }
            this.glPostAcctForm.glacctNo = data.glacctNo.glacctNo
            this.glPostAcctForm.fund = data.glacctNo.fund
            if (data.fund) {
              this.glPostAcctForm.fundDesc = data.fund.fundDesc
            }
            this.glPostAcctForm.acctNoSfx = data.glacctNo.acctNoSfx
            if (data.acctNoSfx) {
              this.glPostAcctForm.acctNoSfxDesc = data.acctNoSfx.description
            }
            this.glPostAcctForm.description = data.glacctNo.description
            this.glPostAcctForm.curr = data.glacctNo.curr
            if (data.curr) {
              this.glPostAcctForm.currDesc = data.curr.currDesc
            }
            this.glPostAcctForm.parentAcctNo = data.glacctNo.parentAcctNo
            this.glPostAcctForm.parentFund = data.glacctNo.parentFund
            this.glPostAcctForm.parentAcctNoSfx = data.glacctNo.parentAcctNoSfx
            this.glPostAcctForm.yrClosed = data.glacctNo.yrClosed
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doInit() {
      this.getComp()
      await this.fetchGLAcctNo()
      const apiURI = this.menu.glPostAcctYrList
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data.hasContent) {
            const { data } = result.data
            if (data) {
              this.acctYrList = []
              data.map((result) => {
                this.acctYrList.push(result)
              })
              this.glPostAcctForm.acctYr = this.acctYrList[this.acctYrList.length - 1].value
              this.fetchGLPostAcct()
            }
            await this.checkCurrYr()
          } else {
            this.doNew()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchGLPostAcct() {
      const apiURI = this.menu.glPostAcct
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          expand.acctYr = this.glPostAcctForm.acctYr
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glPostAcctForm.origBalBf = formatDisplayNumber(data.glPostAcct.origBalBf)
            this.glPostAcctForm.origBal01 = formatDisplayNumber(data.glPostAcct.origBal01)
            this.glPostAcctForm.origBal02 = formatDisplayNumber(data.glPostAcct.origBal02)
            this.glPostAcctForm.origBal03 = formatDisplayNumber(data.glPostAcct.origBal03)
            this.glPostAcctForm.origBal04 = formatDisplayNumber(data.glPostAcct.origBal04)
            this.glPostAcctForm.origBal05 = formatDisplayNumber(data.glPostAcct.origBal05)
            this.glPostAcctForm.origBal06 = formatDisplayNumber(data.glPostAcct.origBal06)
            this.glPostAcctForm.origBal07 = formatDisplayNumber(data.glPostAcct.origBal07)
            this.glPostAcctForm.origBal08 = formatDisplayNumber(data.glPostAcct.origBal08)
            this.glPostAcctForm.origBal09 = formatDisplayNumber(data.glPostAcct.origBal09)
            this.glPostAcctForm.origBal10 = formatDisplayNumber(data.glPostAcct.origBal10)
            this.glPostAcctForm.origBal11 = formatDisplayNumber(data.glPostAcct.origBal11)
            this.glPostAcctForm.origBal12 = formatDisplayNumber(data.glPostAcct.origBal12)
            this.glPostAcctForm.origBal13 = formatDisplayNumber(data.glPostAcct.origBal13)
            this.glPostAcctForm.localBalBf = formatDisplayNumber(data.glPostAcct.localBalBf)
            this.glPostAcctForm.localBal01 = formatDisplayNumber(data.glPostAcct.localBal01)
            this.glPostAcctForm.localBal02 = formatDisplayNumber(data.glPostAcct.localBal02)
            this.glPostAcctForm.localBal03 = formatDisplayNumber(data.glPostAcct.localBal03)
            this.glPostAcctForm.localBal04 = formatDisplayNumber(data.glPostAcct.localBal04)
            this.glPostAcctForm.localBal05 = formatDisplayNumber(data.glPostAcct.localBal05)
            this.glPostAcctForm.localBal06 = formatDisplayNumber(data.glPostAcct.localBal06)
            this.glPostAcctForm.localBal07 = formatDisplayNumber(data.glPostAcct.localBal07)
            this.glPostAcctForm.localBal08 = formatDisplayNumber(data.glPostAcct.localBal08)
            this.glPostAcctForm.localBal09 = formatDisplayNumber(data.glPostAcct.localBal09)
            this.glPostAcctForm.localBal10 = formatDisplayNumber(data.glPostAcct.localBal10)
            this.glPostAcctForm.localBal11 = formatDisplayNumber(data.glPostAcct.localBal11)
            this.glPostAcctForm.localBal12 = formatDisplayNumber(data.glPostAcct.localBal12)
            this.glPostAcctForm.localBal13 = formatDisplayNumber(data.glPostAcct.localBal13)
            this.glPostAcctForm.createdProgId = data.glPostAcct.createdProgId
            this.glPostAcctForm.modifiedProgId = data.glPostAcct.modifiedProgId
            this.glPostAcctForm.createdBy = data.createdBy
            this.glPostAcctForm.createdDate = data.createdDate
            this.glPostAcctForm.modifiedBy = data.modifiedBy
            this.glPostAcctForm.modifiedDate = data.modifiedDate
            this.showDet = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async checkCurrYr() {
      if (this.acctYrList.length === 0) {
        this.currYrExist = false
        return
      }
      const currYr = new Date().getFullYear()
      const apiURI = this.menu.glPostAcct
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          expand.acctYr = currYr
          await this.$http.get(expandURI(apiURI, expand))
          this.currYrExist = true
        } catch (err) {
          this.currYrExist = false
        }
      }
    },
    doNew() {
      this.glPostAcctForm.acctYr = new Date().getFullYear()
      this.showDet = true
      this.newGLPostAcct = true
      this.currYrExist = true
      this.initField()
    },
    initField() {
      this.glPostAcctForm.origBalBf = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal01 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal02 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal03 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal04 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal05 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal06 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal07 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal08 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal09 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal10 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal11 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal12 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.origBal13 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBalBf = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal01 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal02 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal03 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal04 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal05 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal06 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal07 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal08 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal09 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal10 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal11 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal12 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.localBal13 = parseFloat(0).toFixed(2)
      this.glPostAcctForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.glPostAcctForm.createdDate = new Date()
      this.glPostAcctForm.modifiedBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.glPostAcctForm.modifiedDate = new Date()
      this.glPostAcctForm.createdProgId = 'glacctNoParam'
      this.glPostAcctForm.modifiedProgId = 'glacctNoParam'
    },
    formatNumber() {
      for (let k in this.acctMth) {
        const mth = this.acctMth[k]
        if (this.glPostAcctForm['origBal' + mth.value] !== '') {
          this.glPostAcctForm['origBal' + mth.value] = removeFormatNumber(this.glPostAcctForm['origBal' + mth.value])
        }
        if (this.glPostAcctForm['localBal' + mth.value] !== '') {
          this.glPostAcctForm['localBal' + mth.value] = removeFormatNumber(this.glPostAcctForm['localBal' + mth.value])
        }
      }
    },
    async doCreate() {
      this.formatNumber()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.glPostAcctForm.yrClosed != null && this.glPostAcctForm.yrClosed !== 0) {
            if (this.glPostAcctForm.yrClosed < this.comp.currAcctYr) {
              this.$toast.error('This account no. is closed')
              return
            } else {
              const prompt = await this.$refs.confirm.doPopUp()
              if (!prompt) {
                return
              }
            }
          }
          const apiURI = this.menu.createGlPostAcct
          if (apiURI) {
            this.$http
              .post(apiURI, this.glPostAcctForm)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.newGLPostAcct = false
                this.doInit()
                this.fetchGLPostAcct()
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    doCancel() {
      this.$router.push({ name: 'glAcctNoList' })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'glAcctNoDet' && to.name !== 'glBudget') {
      sessionStorage.removeItem('glacctNo')
    }
    next()
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
